import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import ExperienceCard from './ExperienceCard';
import "./ExperienceMain.css";
import ScrollAnimation from '../ScrollAnimation/ScrollAnimation';

const ExperienceMain = () => {


    return (

        <Container fluid >
            <Row>
                <Col>

                    <div class="container">
                        <h1 className='w-exp'>Work Experience</h1>

                        <div class="timeline-item" date-is='20-07-1990'>
                            <div className='inner-circle'></div>
                            <ScrollAnimation component={<ExperienceCard
                                cargo="Senior Software Developer"
                                texto="Nov. 2024 - Present · Rosario, Santa Fe"
                                link="https://www.lucods.com/"
                                empresa="Lucods"
                                texto2={
                                    <ul>
                                        <li>
                                            Modernized legacy DOS-based production workflows into a comprehensive ERP solution, featuring integrated web tools and a mobile app for factory workers. This transformation helped reduce delivery times by 20%, improved management traceability by 33%, and increased production throughput by 35%.
                                        </li>
                                        <li>
                                            Integrated facility data and live PLC signals into real-time web dashboards and mobile interfaces using SignalR, providing production teams with instant event visibility and boosting overall operational efficiency by 40%.
                                        </li>
                                        <li>
                                            Designed and launched a microbus management platform connecting service requesters, management, and operators, featuring automated WhatsApp and email notifications that cut scheduling errors by 25% and saved 10+ hours of manual coordination weekly.
                                        </li>
                                        <li>
                                            Engineered high-converting landing pages for <a style={{ color: 'white' }} href="https://www.amsasrl.com/" target="_blank" rel="noopener noreferrer">AMSA</a>, <a style={{ color: 'white' }} href="https://www.lucods.com/" target="_blank" rel="noopener noreferrer">Lucods</a>, and external clients, increasing average user engagement by 30% and delivering modern, responsive experiences across devices.
                                        </li>
                                    </ul>
                                }
                            >

                            </ExperienceCard>} />



                        </div>
                        <div class="timeline-item" date-is='20-07-1990'>
                            <div className='inner-circle'></div>
                            <ScrollAnimation component={<ExperienceCard
                                cargo="Software Developer"
                                texto="Jul. 2021 - Present · Rosario, Santa Fe"
                                link="https://agraizzaro.dev/"
                                empresa="Autonomous"
                                texto2={
                                    <ul>
                                        <li>
                                            Delivered tailor-made software solutions aligned with complex client specifications, focusing on scalable architecture and maintaining a 98% client satisfaction rating.
                                        </li>
                                        <li>
                                            Engineered applications across C#, Python, and JavaScript ecosystems, translating business needs into robust technical solutions that accelerated client time-to-market by 25%.
                                        </li>
                                        <li>
                                            Enforced rigorous code quality standards and optimized application performance, reducing server response latency by 35% and supporting high system stability.
                                        </li>
                                    </ul>
                                }
                            >

                            </ExperienceCard>} />



                        </div>
                    

                        <div class="timeline-item" date-is='20-07-1990'>
                            <div className='inner-circle'></div>

                            <ScrollAnimation component={<ExperienceCard
                                cargo="Backend Developer"
                                texto="Jan. 2022 - Jul. 2023 · Rosario, Santa Fe"
                                link="https://www.educativa.com/ejecutiva/"
                                empresa="E-ducativa"
                                texto2={
                                    <ul>
                                        <li>
                                            Engineered migration APIs and automated data pipelines to facilitate large-scale client transitions for over 10,000 active user accounts.
                                        </li>
                                        <li>
                                            Automated data processing and migration tasks with Python, cutting manual data-handling time by 60% and eliminating human error.
                                        </li>
                                        <li>
                                            Optimized search performance and database queries, improving query execution speed by 45% while championing GDPR-aligned data management and privacy standards.
                                        </li>
                                    </ul>
                                }>

                            </ExperienceCard>} />



                        </div>

                        <div class="timeline-item" date-is='20-07-1990'>
                            <div className='inner-circle'></div>

                            <ScrollAnimation component={<ExperienceCard
                                cargo="Fullstack Developer"
                                texto="Jun. 2021 - Feb. 2022 · Torremolinos, Spain"
                                link="https://sea-style.onrender.com/"
                                empresa="Sea-Style"
                                texto2={
                                    <ul>
                                        <li>
                                            Developed core e-commerce capabilities for apparel and accessories, including secure Stripe payments and automated order-to-inventory workflows that reduced checkout drop-offs by 18%.
                                        </li>
                                        <li>
                                            Built admin tools and REST APIs for platform operations, cutting internal administrative processing time by 40%.
                                        </li>
                                        <li>
                                            Revamped the customer-facing interface and internal processes, driving a 22% increase in mobile conversion rates and measurable usability improvements.
                                        </li>
                                    </ul>
                                }
                            >

                            </ExperienceCard>} />



                        </div>

                    </div>


                    <Container >
                        <br />

                        <h1 className='w-exp'>Projects</h1>


                    </Container>


                </Col>
            </Row>
        </Container>


    )
}

export default ExperienceMain
